import React, { useState } from 'react';
import { Tooltip, Card, CardContent, Grid, Typography } from '@material-ui/core';
import { Box, ClickAwayListener } from '@mui/material';
import { makeStyles, Theme } from '@material-ui/core/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { COLOR_PRIMARY_DARK, COLOR_GREEN, COLOR_RED, COLOR_YELLOW } from 'src/const';

const useStylesRoot = makeStyles({
  tooltip: {
    padding: 0,
    width: 400,
  },
});

const useStyles = makeStyles((theme: Theme) => ({
  confidenceScoreIcon: {
    cursor: 'pointer',
    width: 40,
    height: 40,
    borderRadius: '40px 40px 0px 40px ',
    transform: 'rotate(45deg)',
    marginBottom: 10,
  },
  confidenceBar: {
    height: 10,
    borderRadius: 10,
    background: `linear-gradient(to right, ${COLOR_RED}, ${COLOR_RED} 40%, ${COLOR_YELLOW} 40%, ${COLOR_YELLOW} 70%, ${COLOR_GREEN} 70%)`,
    display: 'flex',
    flexDirection: 'row',
  },
}));

const DataInsightsTooltip = ({ component, confidenceScoreRelatedData, open, setOpen }) => {
  const rootClass = useStylesRoot();
  const classes = useStyles();

  const dataQualityScore = Math.round(confidenceScoreRelatedData.confidenceScore);
  const distance = Math.round(confidenceScoreRelatedData.distance);
  const isNumberOfBathroomDifference = confidenceScoreRelatedData.isNumberOfBathroomDifference;
  const isHouseTypeOrPoolDifference = confidenceScoreRelatedData.isHouseTypeOrPoolDifference;

  return (
    <Tooltip
      interactive
      classes={rootClass}
      style={{ zIndex: 1000000 }}
      placement="left"
      enterTouchDelay={0}
      leaveTouchDelay={60000}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => {
        // matchMedia('(hover:hover)').matches && setOpen(false);
        setOpen(false);
      }}
      title={
        <Card>
          <CardContent style={{ zIndex: 1000000 }}>
            <Grid container direction="column" spacing={2} style={{ padding: '0 10px' }}>
              {!matchMedia('(hover:hover)').matches && (
                <IconButton
                  aria-label="close"
                  size="small"
                  sx={{ position: 'absolute', top: '10px', right: '30px' }}
                  onClick={() => setOpen(false)}
                >
                  <CloseIcon />
                </IconButton>
              )}

              <Grid
                container
                item
                xs={12}
                direction="row"
                justify="space-between"
                alignItems="center"
              >
                <Grid container item direction="column">
                  <Typography style={{ fontSize: 20, fontWeight: 'bold' }}>
                    Data Quality Insights
                  </Typography>
                  <Typography variant="body2">{getSuggestionText(dataQualityScore)}</Typography>
                </Grid>
              </Grid>

              <Grid item container direction="column" style={{ padding: '0px 20px' }} xs={12}>
                <div
                  className={classes.confidenceScoreIcon}
                  style={{
                    position: 'relative',
                    top: 0,
                    left: `${dataQualityScore - 9}%`,
                    background: getConfidenceIconColor(dataQualityScore),
                  }}
                >
                  <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                    style={{ width: '100%', height: '100%' }}
                  >
                    <Typography
                      style={{
                        color:
                          getConfidenceIconColor(dataQualityScore) === COLOR_RED
                            ? '#fff'
                            : COLOR_PRIMARY_DARK,
                        fontWeight: 'bold',
                        transform: 'rotate(-45deg)',
                      }}
                    >
                      {dataQualityScore}
                    </Typography>
                  </Grid>
                </div>
                <div className={classes.confidenceBar} id="confidenceBar">
                  {[40, 69].map((scale, index) => (
                    <div
                      key={index}
                      style={{
                        width: 2,
                        height: 10,
                        background: '#fff',
                        position: 'relative',
                        top: 0,
                        left: `${scale}%`,
                      }}
                    ></div>
                  ))}
                </div>
              </Grid>

              <Grid item container direction="column" xs={12} spacing={2}>
                <Grid item>
                  <Typography style={{ fontSize: 18, fontWeight: 'bold' }}>Similarity</Typography>
                </Grid>

                <Grid item>
                  <Typography variant="body2" color="textSecondary">
                    How far is this listing located from the given address?{' '}
                    <Box sx={{ display: 'inline', fontWeight: 'bold' }}>{distance} meters</Box>
                  </Typography>
                </Grid>

                <Grid item>
                  <Typography variant="body2" color="textSecondary">
                    Has the same number of bathrooms?{' '}
                    <Box sx={{ display: 'inline', fontWeight: 'bold' }}>
                      {isNumberOfBathroomDifference ? 'No' : 'Yes'}
                    </Box>
                  </Typography>
                </Grid>

                <Grid item>
                  <Typography variant="body2" color="textSecondary">
                    Is property type exactly matching?{' '}
                    <Box sx={{ display: 'inline', fontWeight: 'bold' }}>
                      {isHouseTypeOrPoolDifference ? 'No' : 'Yes'}
                    </Box>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      }
    >
      <div onClick={() => setOpen(true)}>{component}</div>
    </Tooltip>
  );
};

const getSuggestionText = (score: number) => {
  if (score > 70) return 'Great';
  else if (score > 40) return 'Good';
  else return 'Poor';
};

const getConfidenceIconColor = (score: number) => {
  if (score > 70) return COLOR_GREEN;
  else if (score > 40) return COLOR_YELLOW;
  else return COLOR_RED;
};

export default DataInsightsTooltip;
